@if (product().data?.media | findMediaByLabel : 'dimensions') {
<div class="w-12 ratio-1-1">
    <img class="rf"
         [image]="product().data.media | findMediaByLabel : 'dimensions'">
</div>
}
<product-view-dimensions-and-details [product]="product()"
                                     [rightView]="!client.isS"
                                     [icons]="content().dimensions_icons"
                                     [topAttributes]="content().dimensionsTopAttributes"
                                     [sections]="content().dimensions_sections" />